import React from "react";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { CloseIconSvg, GeneralContainer } from "./AllEventPrompt.styled";
import EventPrompt from "../EventsPrompt/EventsPrompt";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import SurveyPrompt from "../SurveyPrompt/SurveyPrompt";
import PropTypes from "prop-types";

const AllEventPrompts = ({
  setEventsAssigned,
  eventsAssigned,
  setOpenNotifiModal,
  surveysAssigned,
  notificationEvent,
  handleEncriptParametersSurvey,
}) => {
  const handleClose = (id) => {
    if (id) {
      const filteredEvents = eventsAssigned.filter((e) => e.idEvent !== id);
      setEventsAssigned(filteredEvents);
    }
  };
  const newNotificationEvent =
    notificationEvent != "" ? JSON.parse(notificationEvent) : {};
  const eventNew =
    Object.keys(newNotificationEvent).length !== 0
      ? {
          idEvent: newNotificationEvent.IdEvent,
          eventName: newNotificationEvent.EventName,
          description: newNotificationEvent.Description,
          photo: newNotificationEvent.UrlPhoto,
        }
      : {};

  return (
    <GeneralContainer>
      <h2 className="modal-notification_title">
        Notifications
        <Tooltip title="close">
          <IconButton
            className="align-right close"
            onClick={() => setOpenNotifiModal(false)}
          >
            <CloseIconSvg>
              <CloseIcon />
            </CloseIconSvg>
          </IconButton>
        </Tooltip>
      </h2>
      {Object.keys(eventNew).length !== 0 && (
        <EventPrompt
          classIdentity={"red-card"}
          event={eventNew}
          handleClose={handleClose}
        />
      )}
      {surveysAssigned.length > 0 &&
        surveysAssigned.map((survey) => {
          return (
            <SurveyPrompt
              key={survey?.idSurvey}
              classIdentity={survey?.cardClass ? survey.cardClass : "red-card"}
              handleEncriptParametersSurvey={handleEncriptParametersSurvey}
              survey={survey}
              handleClose={handleClose}
            />
          );
        })}
      {eventsAssigned.length > 0 &&
        eventsAssigned.map((event) => {
          return (
            <EventPrompt
              key={event?.idEvent}
              classIdentity={"red-card"}
              event={event}
              handleClose={handleClose}
            />
          );
        })}
    </GeneralContainer>
  );
};

export default AllEventPrompts;

AllEventPrompts.propTypes = {
  notificationEvent: PropTypes.string,
  eventsAssigned: PropTypes.array,
  setEventsAssigned: PropTypes.func,
  setOpenNotifiModal: PropTypes.func,
  surveysAssigned: PropTypes.array,
  handleEncriptParametersSurvey: PropTypes.func,
}